import { render } from "./ListTransfersfromCashierBank.vue?vue&type=template&id=1e6c664a&scoped=true"
import script from "./ListTransfersfromCashierBank.vue?vue&type=script&lang=js"
export * from "./ListTransfersfromCashierBank.vue?vue&type=script&lang=js"

import "./ListTransfersfromCashierBank.vue?vue&type=style&index=0&id=1e6c664a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6c664a"]])

export default __exports__